"use client";
import { cn } from "@/lib/utils";
import { getBaseUrl } from "@/util/get-base-url";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
import { useTranslation } from "@/app/i18n/client";
import Link from "next/link";

export const ArticleCard = ({
    article,
    pathPrefix = "/blogs/editorial",
    display,
    priorityImage,
    loc,
    date,
}: {
    article: any;
    pathPrefix?: string;
    display?: "CARD" | "DEFAULT";
    priorityImage?: boolean;
    loc?: string;
    date?: string;
}) => {
    const { t } = useTranslation(loc);
    const displayType = display ?? "DEFAULT";
    const colorStyle = useContext(ColorStyleContext);
    return (
        <div className="w-fit p-0 flex flex-col items-center h-full rounded-lg overflow-hidden">
            <a href={`${pathPrefix}/${article.handle}`}>
                <picture>
                    <source
                        srcSet={
                            article.imageUrl != ""
                                ? `${getBaseUrl(article.imageUrl)}.avif`
                                : "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg"
                        }
                        type="image/avif"
                    />
                    <source
                        srcSet={
                            article.imageUrl != ""
                                ? `${getBaseUrl(article.imageUrl)}.webp`
                                : "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg"
                        }
                        type="image/webp"
                    />
                    <img
                        src={article.imageUrl}
                        alt={article.imageAlt || article.attributes?.title}
                        width={388}
                        height={200}
                        className={cn(
                            "object-cover aspect-[19/10] rounded-lg"
                        )}
                        // priority={priorityImage ? true : undefined}
                        loading={priorityImage ? "eager" : "lazy"}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = "https://dummyimage.com/388x200/e9e9e9/e9e9e9.jpg";
                        }}
                    />
                </picture>
            </a>
            <div className="flex flex-col items-start w-full max-w-[388px] h-40 gap-4 mt-4"
                style={{ backgroundColor: colorStyle?.contentBg || "#ffffff" }}>
                <p
                    className="text-lg font-light text-wrap text-ellipsis line-clamp-1"
                    style={
                        {
                            color: colorStyle?.tableText || "#747474",
                        } as React.CSSProperties
                    }>
                    {date}
                </p>
                <h3 className="text-[18px] font-semibold text-wrap text-ellipsis line-clamp-2">
                    {article.attributes?.title}
                </h3>
                <Link
                    href={`${pathPrefix}/${article.handle}`}
                    className="text-[18px] font-normal dynamic-color break-word overflow-hidden"
                    style={
                        {
                            "--dynamic-color": colorStyle?.link || "#006ef2",
                            "--dynamic-hover-color": colorStyle?.linkHover || "#254b7c",
                            "--dynamic-focus-color": colorStyle?.linkHover || "#254b7c",
                            maxHeight: "calc(2 * 2.8rem)",
                        } as React.CSSProperties
                    }>
                    {t("article.read_more")}
                </Link>      
            </div>
            
        </div>
    );
};
